<template>

    <v-container>
  <v-snackbar xs12
    v-model="snackbar"
    multi-line
    :timeout="timeout"
    top
    color="orange"
  >
    {{ alertmessage }}
    <v-btn
      color="white"
      text
      @click="snackbar = false"
    >
      Close
    </v-btn>
  </v-snackbar>      
<v-row>
  <v-col>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      color="primary"
    ></v-progress-linear>
  </v-col>
</v-row>      
<v-row wrap>
  <v-col>    
    <base-material-card
      v-if="!loading"
      color="primary"
      icon="mdi-comment-processing-outline"
      inline
    >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light">
        Smart Safe Commands
      </div> 
    </template>    
    <v-col cols="12">
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-col>
    <v-row>
      <v-col
      sm="12"
      >
        <v-card
          class="pa-2"
          outlined
          tile
        >
    <v-toolbar flat color="white">   
      <v-dialog v-model="dialog" >
        <template v-slot:activator="{ on }">
          <v-btn color="success" dark class="mb-2" v-on="on">Add Command</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4 lg6>
                  <v-text-field v-model="editedItem.idnum" label="Name"></v-text-field>
                </v-flex>            
                <v-flex xs12 sm6 md12 lg6>
                  <v-text-field v-model="editedItem.address" label="Category"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md12 lg12>
                  <v-text-field v-model="editedItem.city" label="Command"></v-text-field>
                </v-flex>                                                                                                   
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" :disabled="!formIsValid" @click="save" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-spacer></v-spacer>

    </v-toolbar> 
   
    <v-data-table
      :headers="headers"
      :search="search"
      :items="currentmachines"
      class="elevation-1"
    >
    
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.idnum }}</td>
        <td class="text-xs-left">{{ props.item.category }}</td>
        <td class="text-xs-left">{{ props.item.command }}</td>
      </template>
      <template v-slot:item.action="{ item }" v-if="userallowed">

          <v-icon
            
            color="primary"
            size="20"
            @click="editItem(item)"
          >
          mdi-square-edit-outline
          </v-icon>
          <v-icon
            
            color="black"
            size="20"
            class="ma-4"
            @click="deleteItem(item)"
          >
          mdi-delete-forever
          </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary">Reset</v-btn>
      </template>
    </v-data-table>

        </v-card>
      </v-col>     
    </v-row>    
    </base-material-card>

    <v-spacer></v-spacer>    
  </v-col>
</v-row>
    </v-container>

 
</template>

<script>
  // Components

  export default {
    data: () => ({
      search: '',
      dialog: false,
      time: null,
      newgroup: '',
      snackbar: false,
      timeout: 5000,
      alertmessage: '',
      currentgroups: '',
      menu2: false,
      menu3: false,
      menu4: false,
      modal2: false,
      loading: false,
      headers: [     
        { text: 'Name', value: 'idnum', align: 'left' },
        { text: 'Category', value: 'group', align: 'left' },
        { text: 'Command', value: 'address', align: 'left' },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      sites: [],
      editedIndex: -1,
      editedItem: {
        idnum: '',
        crypto_idnum: '',
        originalidnum: '',
        sitekey: '',
        address: '',
        city: '',
        zipcode: '',
        group: '',
        allowedusers: null,
        wifipw: '',
        wifiaccess: '',
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '',
        time_close: '',
        time_eod: ''
      },
      defaultItem: {
        idnum: '',
        crypto_idnum: '',
        originalidnum: '',
        address: '',
        sitekey: '',
        city: '',
        zipcode: '',
        wifipw: '',
        wifiaccess: '',
        group: '',
        allowedusers: [],
        country: '',
        sitecontactnumber: '',
        sitecontactname: '',
        supportemail: '',
        supportnumber: '',
        timezone: '',
        time_open: '',
        time_close: '',
        time_eod: ''
      }
    }),

    computed: {
      formIsValid () {
        return this.editedItem.idnum !== '' &&
        this.editedItem.address !== '' &&
        this.editedItem.city !== '' &&
        this.editedItem.zipcode !== '' &&
        this.editedItem.group !== '' &&
        this.editedItem.sitecontactnumber !== '' &&
        this.editedItem.sitecontactname !== '' &&
        this.editedItem.supportemail !== '' &&
        this.editedItem.supportnumber !== '' &&
        this.editedItem.timezone !== '' &&
        this.editedItem.time_open !== '' &&
        this.editedItem.time_close !== '' &&
        this.editedItem.time_eod !== ''
      },      
      getcurrentgroups () {
        this.currentgroups = this.$store.getters.usergroups
        return this.currentgroups
      },      
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      userallowed() {
        
        if (parseInt(this.$store.getters.user.level) >= 500) {

          return true
        }

        return false
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Site' : 'Edit Site'
      },
      currentmachines () {
        this.sites = this.$store.getters.loadedSites
        return this.sites
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }      
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadcommands')
      this.sites = this.$store.getters.loadedSites
      this.tokens = this.$store.getters.loadedTokens
    },

    methods: {
      userlist (group) {
        let people = this.$store.getters.userprofiles
        let usersfromgroup = people.filter(person => person.group === group)
        return usersfromgroup.map(usr => usr.email)
      },
      addgroup () {
        if (this.newgroup) {
          // this.currentgroups.push(this.newgroup)
          this.$store.dispatch('createUserGroup', this.newgroup)
          // make sure to load on a good add to the db
          this.$store.dispatch('loadUserGroups')
          this.newgroup = ''
        }
      },
      removeGroup (index) {
        let numelements = 1
        let grp = this.currentgroups[index]
        this.currentgroups.splice(index, numelements)
        this.$store.dispatch('removeUserGroup', grp)
        this.$store.dispatch('loadUserGroups')
      },
      editItem (item) {
        this.editedIndex = this.sites.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.sites.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') && this.sites.splice(index, 1)) {
          this.$store.dispatch('loadcommands')
          this.$store.dispatch('removeCommand', item)
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        this.editedItem.name = this.editedItem.name.trim()
        this.editedItem.name = this.editedItem.name.replace(/\t/g, '');
        if (this.editedItem.name === "") {
          this.alertmessage = '# . $ are not allowed in a site name'
          this.snackbar = true
          this.close()
          return
        }
        // check unallowed chars?
        let notallowedchars = ""
        notallowedchars = this.editedItem.name.match(/\\t|[#\$\.]/gi)
        if (notallowedchars) {
          this.alertmessage = '# . $ are not allowed in a command name'
          this.snackbar = true
          this.close()
          return
        }        
        const commandData = {
          name: this.editedItem.name.trim(),
          category: this.editedItem.category.trim(),
          command: this.editedItem.command.trim()
        }

        if (this.editedIndex > -1) {

          if (this.editedItem.idnum !== this.editedItem.originalidnum) {
            // clone the profile to the new name
          }
          let rec = {
            name: this.editedItem.name,
            category: this.editedItem.category,
            command: this.editedItem.command
          }
          this.$store.dispatch('updateCommand', machineData)

          Object.assign(this.sites[this.editedIndex], this.editedItem)
        } else {
          this.$store.dispatch('createCommand', machineData)
          this.sites.push(this.editedItem)
        }
        this.$store.dispatch('loadcommands')
        this.sites = this.$store.getters.loadedSites
        this.tokens = this.$store.getters.loadedTokens
        this.close()
      }
    }
  }
</script>
<style>
  .card--flex-toolbar {
    margin-top: -64px;
  }
</style>
